/** 弹窗控制器脚本基类 */
export class BasePopupScript {
  _PopupEventName = null

  /**
   * @param { string } eventName
   */
  constructor (eventName) {
    if (!eventName) {
      throw new Error('需要传入指定的事件名，用于触发对应的弹窗事件')
    }
    this._PopupEventName = eventName
  }

  /** 重置数据 */
  reset () {
    throw new Error('未实现 reset')
  }

  /** 是否符合弹出要求 */
  valid () {
    throw new Error('未实现 valid')
  }

  /** 获取对应的事件名
   * @returns {string}
   */
  getEventName () {
    return this._PopupEventName
  }

  /** 设置展示过的标记 */
  setHasShowTag () {
    throw new Error('未实现 setHasShowTag')
  }

  /** 更新内部一些数据
   * @param {Object} route 当前路由
   * @param {Object} store vuex
   */
  updateData (route, store) {
    throw new Error('未实现 updateData')
  }
}
